import { getApi } from '../../../shared/api/index';

export const api = getApi();
